"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var Overview_less_1 = __importDefault(require("./Overview.less"));
var PRIMARY_INPUTS_COUNT = 2;
var Overview = function (_a) {
    var inputs = _a.inputs, onFilterClick = _a.onFilterClick;
    var t = (0, react_i18next_1.useTranslation)().t;
    var groups = [inputs.slice(0, PRIMARY_INPUTS_COUNT), inputs.slice(PRIMARY_INPUTS_COUNT)].filter(function (group) { return group.length > 0; });
    var onClick = (0, react_1.useCallback)(function (event) {
        var id = event.currentTarget.dataset.id;
        if (typeof id === 'string') {
            onFilterClick(id);
        }
    }, [onFilterClick]);
    return (react_1.default.createElement("div", { className: Overview_less_1.default['overview'] }, groups.map(function (group) { return (react_1.default.createElement("div", { key: group[0].id, className: Overview_less_1.default['group'] }, group.map(function (input) {
        var _a;
        var selected = input.options.find(function (_a) {
            var value = _a.value;
            return value === input.value;
        });
        return (react_1.default.createElement("button", { key: input.id, type: 'button', className: Overview_less_1.default['filter-row'], disabled: input.options.length === 0, "data-id": input.id, onClick: onClick },
            react_1.default.createElement("span", { className: Overview_less_1.default['row-copy'] },
                react_1.default.createElement("span", { className: Overview_less_1.default['filter-label'] }, input.label),
                react_1.default.createElement("span", { className: (0, classnames_1.default)(Overview_less_1.default['value'], (_a = {}, _a[Overview_less_1.default['active']] = input.active, _a)) }, selected ? (selected.default ? t('ALL') : selected.label) : t('NONE')),
                (selected === null || selected === void 0 ? void 0 : selected.description) ?
                    react_1.default.createElement("span", { className: Overview_less_1.default['description'] }, selected.description)
                    :
                        null),
            react_1.default.createElement(react_2.default, { name: 'chevron-forward' })));
    }))); })));
};
exports.default = Overview;
